import { useState } from "react";
import { Pencil, Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const IssueEditor = ({ guide, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [n, setN] = useState(String(guide.issue_number));
  const save = async () => {
    try {
      await api.patch(`/guides/${guide.id}/issue`, { issue_number: Number(n) });
      toast.success(`Now No. ${n} — re-typesetting the PDF, sample and Instagram images`);
      setEdit(false);
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!edit) return (
    <button data-testid="issue-edit-button" onClick={() => { setN(String(guide.issue_number)); setEdit(true); }} disabled={!["done", "failed"].includes(guide.status)}
      className="inline-flex items-center gap-1 hover:text-[var(--g-dark,#3B1B48)] transition-colors" title="Change issue number">
      No. <span data-testid="guide-issue-number">{guide.issue_number}</span><Pencil className="w-3 h-3" />
    </button>
  );
  return (
    <span className="inline-flex items-center gap-1">
      No.<input data-testid="issue-number-input" type="number" min="1" value={n} onChange={(e) => setN(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()}
        className="w-16 h-6 px-1 border border-[var(--g-accent,#C59B27)] bg-white text-[var(--g-dark,#3B1B48)] text-xs" autoFocus />
      <button data-testid="issue-save-button" onClick={save} disabled={!Number(n)} className="text-[#2D6A4F]"><Check className="w-4 h-4" /></button>
      <button data-testid="issue-cancel-button" onClick={() => setEdit(false)} className="text-[#8C827A]"><X className="w-4 h-4" /></button>
    </span>
  );
};
